// ════════════════════════════════════════════════════════════════════
// src/services/auditoria.js — quem fez o quê
// ════════════════════════════════════════════════════════════════════
// Com três pessoas mexendo na mesma base, a permissão não é a proteção
// real — o registro é. A carteira é UM documento só (clientes/dados), e
// permissão no Firestore é por documento: quem pode gravar, grava tudo.
// Então o que te salva de "sumiu um cliente" não é impedir, é saber quem.
//
// Registro é melhor-esforço: se falhar, a ação principal segue. Nunca
// coloque await disto no caminho crítico de um salvamento.
// ════════════════════════════════════════════════════════════════════

import { db } from './firebase';
import { collection, addDoc } from 'firebase/firestore';

export async function registrar(contaUid, { user, papel, acao, alvo, detalhe }) {
  if (!contaUid || !acao) return;
  try {
    await addDoc(collection(db, 'users', contaUid, 'auditoria'), {
      acao,                                   // ex: 'equipe.convidou'
      alvo: alvo || '',                       // ex: o e-mail convidado
      detalhe: detalhe || '',                 // texto curto e legível
      porUid: user?.uid || '',
      porEmail: user?.email || '',
      porNome: user?.displayName || '',
      papel: papel || '',
      em: new Date().toISOString(),
    });
  } catch (e) {
    // registro nunca derruba a operação de verdade
    console.warn('auditoria', e?.message || e);
  }
}
